import i18n from "../../../../../translations/strings";

export enum CsvUploadModalVariant {
    Add = "Add",
    Edit = "Edit"
}

export const CsvUploadModalTitle = {
    [CsvUploadModalVariant.Add]: i18n.t('reservations.addListAttendees'),
    [CsvUploadModalVariant.Edit]: i18n.t('reservations.editListAttendees'),
};